/* Style 1 cards initialize automatically, including AJAX section replacements. */
if (!customElements.get('product-card-style-one')) {
  customElements.define('product-card-style-one', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.matches('[data-variant-select]')) {
          this.querySelectorAll('[data-variant-select]').forEach((option) => {
            option.classList.toggle('is-selected', option === button);
            option.setAttribute('aria-pressed', String(option === button));
          });
          const add = this.querySelector('.pc1-card__footer [data-add-to-cart]');
          add.dataset.variantId = button.dataset.variantId;
          add.dataset.available = button.dataset.available;
          add.disabled = button.dataset.available !== 'true';
          add.querySelector('.pc1-add-btn__text').textContent = add.disabled ? 'Sold out' : add.dataset.addLabel;
        } else if (button.matches('[data-variants-open]')) {
          this.querySelector('dialog').showModal();
        } else if (button.matches('[data-modal-close]')) {
          this.querySelector('dialog').close();
        } else if (button.matches('[data-add-to-cart]')) {
          this.addToCart(button);
        }
      });
      this.querySelector('[data-modal-close].pc1-modal__overlay')?.addEventListener('click', () => this.querySelector('dialog').close());
    }

    async addToCart(button) {
      if (button.disabled || this.busy) return;
      this.busy = true;
      button.disabled = true;
      button.classList.add('is-loading');
      const status = this.querySelector('.pc1-status');
      status.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
          bubbles: true, detail: { sections }
        }));
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: button.dataset.variantId, quantity: 1, sections: [...new Set(sections)], sections_url: location.pathname })
        });
        const cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'Could not add to cart');
        this.querySelector('dialog[open]')?.close();
        const events = window.MinimogTheme?.pubSubEvents;
        if (window.MinimogEvents && events) {
          window.MinimogEvents.emit(events.cartUpdate, { cart, productVariantId: button.dataset.variantId });
        }
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: cart } }));
        const drawer = document.querySelector('m-cart-drawer');
        if (drawer && window.MinimogSettings?.enable_cart_drawer) {
          drawer.open();
        } else {
          window.location.assign(window.MinimogSettings?.routes?.cart || root + 'cart');
        }
      } catch (error) {
        // Put the message inside the open dialog so it remains visible on errors.
        const dialog = this.querySelector('dialog[open] .pc1-modal__dialog');
        (dialog || this).appendChild(status);
        status.textContent = error.message || 'Could not add to cart';
        status.hidden = false;
      } finally {
        this.busy = false;
        button.classList.remove('is-loading');
        button.disabled = button.dataset.available !== 'true';
      }
    }
  });
}
